module.exports = __webpack_public_path__ + "static/media/stedelijk.a4499eb9.jpg";